import { Customer } from "../Customer/schema";

export const MissingCustomer: Customer = {
  uuid: "missing",
  nickname: "Missing Customer",
  createdAt: "",
  icon: null,
};
